// reducers rootReducer
// https://redux.js.org/recipes/structuring-reducers/normalizing-state-shape
// https://redux.js.org/recipes/structuring-reducers/immutable-update-patterns
// https://github.com/erikras/react-redux-universal-hot-example/issues/962

import { combineReducers } from 'redux';
import datasetsReducer from './datasetsReducer';
import tabsReducer from './tabsReducer';
import facetsReducer from './facetsReducer';
import cardsReducer from './cardsReducer';
import generalReducer from './generalReducer';

const rootReducer = combineReducers({
  datasets: datasetsReducer,
  tabs: tabsReducer,
  facets: facetsReducer,
  cards: cardsReducer,
  general: generalReducer,
});

export default rootReducer;
